import { useQueryClient } from 'react-query';

import { useIsSuccessful } from '@/common/hooks';
import { BaseQueryParams } from '@/common/interfaces';

import { AddressChangerSocketEventNames, useAddressChangerSocket } from '@/modules/AddressChanger';
import { SiteSearchConsoleQueryKeys, useGetSitesSearchConsoleInfoQuery } from '@/modules/Domains';
import { Site } from '@/modules/Sites';

type Data = {
  siteId: string;
} & Site['searchConsoleAddressChanging'];

interface Args {
  siteId: string;
}

export const useUpdateAddressChangingStatus = ({ siteId }: Args) => {
  const queryClient = useQueryClient();

  const isInfoRequestSuccess = useIsSuccessful({ queryKey: [SiteSearchConsoleQueryKeys.GetInfo, siteId] });

  useAddressChangerSocket<Data>(AddressChangerSocketEventNames.UpdateChangingStatus, ({ lastMessage }) => {
    const { siteId: id, ...redirectParams } = lastMessage;

    if (siteId && isInfoRequestSuccess && siteId === id) {
      queryClient.setQueryData<
        BaseQueryParams<typeof useGetSitesSearchConsoleInfoQuery>['data']
      >([SiteSearchConsoleQueryKeys.GetInfo, siteId], (data) => {
        return {
          ...data,
          searchConsoleAddressChanging: redirectParams
        } as BaseQueryParams<typeof useGetSitesSearchConsoleInfoQuery>['data'];
      });
    }
  });
};
